import { Context } from "%/dynamic-component-editor/classes/context-v2";

// A binding may name a field on the entity it is bound to ("score") or walk a
// reference to reach one ("user.name"). App#getEntityField resolves the second
// by hopping entity to entity, so every check in the editor has to walk the
// same way or it calls a working binding broken.
//
// Callers differ only in how they look an entity up, so that is the parameter.
// Resolution stops at the first hop the lookup cannot answer and says so --
// "not loaded" is a load-ordering state, never a broken binding.

export const PATH_OK = "ok";
export const PATH_MISSING_FIELD = "missingField";
export const PATH_NOT_A_REFERENCE = "notAReference";
export const PATH_UNRESOLVED = "unresolved";

// → { status, field?, entityType?, fields?, segment? }
export function resolveEntityFieldPath({ fields, fieldName, entityType, lookupEntity }) {
  const segments = String(fieldName ?? "").split(".");
  let currentFields = fields;
  let currentType = entityType;
  for (let index = 0; index < segments.length; index += 1) {
    const segment = segments[index];
    if (!currentFields) {
      return { status: PATH_UNRESOLVED, entityType: currentType, segment };
    }
    const field = currentFields[segment];
    if (!field) {
      return { status: PATH_MISSING_FIELD, entityType: currentType, fields: currentFields, segment };
    }
    if (index === segments.length - 1) {
      return { status: PATH_OK, field, entityType: currentType };
    }
    if (!field.entity) {
      return { status: PATH_NOT_A_REFERENCE, entityType: currentType, fields: currentFields, segment };
    }
    currentType = field.entity;
    currentFields = lookupEntity(field.entity)?.fields;
  }
  return { status: PATH_UNRESOLVED, entityType: currentType };
}

// An entity's config by NAME across every registered source: a reference
// routinely points outside its own app (every app's `user` is the platform
// User), so the owning app is not known up front.
export function referencedEntityConfig(entityName) {
  if (!entityName) {
    return null;
  }
  for (const [appName, source] of Object.entries(Context.allSources ?? {})) {
    const config = source?.entities?.[entityName];
    if (config?.fields) {
      return { ...config, entityType: config.entityType ?? entityName, appName: config.appName ?? appName };
    }
  }
  return null;
}
